import React from 'react';
import './Project.scss';

export default function Project(props) {
    const { title, link, bg, desktop, mobile, description } = props;

    return (
        <div className="project-container">
            <h3>{title}</h3>
            <div className="project-data">
                <div className="project-bg">
                    <img src={bg} alt={`${title} background`} />
                </div>
                <div className="project-screens">
                    {desktop && (
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <img src={desktop} alt={`${title} desktop`} className="device desktop" />
                        </a>
                    )}
                    {mobile && (
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <img src={mobile} alt={`${title} mobile`} className="device mobile" />
                        </a>
                    )}
                </div>
                <div className="project-description">
                    <p>{description}</p>
                </div>
                <div className="project-link">
                    {link.includes('http') ? (
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <button>View Project</button>
                        </a>
                    ) : (
                        <button disabled>{link ? link : 'Offline'}</button>
                    )}
                </div>
            </div>
        </div>
    );
}

